<template>
<v-container fluid grid-list-md>
  <v-data-iterator
  content-tag='v-layout'
  row
  wrap
  :items='channelValues'
  :rows-per-page-items='rowsPerPageItems'
  :pagination.sync='pagination'
  id='dataAgg'
  >
  <v-flex
  slot='item'
  slot-scope='props'
  lg4
  >
  <v-card>
    <v-btn
      @click.native='editEntry(props.item)'
      fab
      absolute
      top
      right
      small
      >
      <v-icon>edit</v-icon>
    </v-btn>

    <v-subheader><h4>{{props.item[fields[1].name]}}</h4></v-subheader>
              <v-list dense>
              <v-list-tile v-for='(fieldInfo, key) in fields' :key='key' v-if='key > 1'>

                <v-list-tile-content>{{fieldInfo.name}}</v-list-tile-content>
                  <v-list-tile-content class='align-end'>
                    {{props.item[fieldInfo.name]}}
                  </v-list-tile-content>
                </v-list-tile>
                </v-list>
  </v-card>
</v-flex>
</v-data-iterator>
<v-flex lg4 offset-lg4>
<v-layout row wrap>
<v-flex>
  <v-btn
   @click.native='newEntry'
   v-if='!formShow'
   color='success'
   fab
   absolute
   bottom
   left>
   <v-icon>add</v-icon>
 </v-btn>
<v-card v-if='formShow'>
<v-card-title v-if='newInput'>New {{channelPath}} entry</v-card-title>
<v-card-title v-else>Update {{channelPath}}</v-card-title>
  <v-container>
  <v-layout row wrap>
    <v-flex xs12 v-for='(fieldInfo, key) in fields' :key='key' v-if='key > 0'>
      <v-text-field
        :name='fieldInfo.name'
        :label='fieldInfo.name'
        id='key'
        v-model='inputFields[key]'
        type='text' >
      </v-text-field>
    </v-flex>
    <v-flex xs3>
      <v-btn v-if='newInput' @click.native='pushData'>Add</v-btn>
      <v-btn v-else @click.native='pushData'>Update</v-btn>
    </v-flex>
    <v-flex xs3>
      <v-btn @click.native='cancelForm'>Cancel</v-btn>
    </v-flex>
    <v-flex xs3>
    </v-flex>
  </v-layout>
  </v-container>
</v-card>
</v-flex>
</v-layout>
</v-flex>
</v-container>
</template>
<script>
import {db} from '../../firebase/firebase'
export default {
  name: 'data-channel',
  data () {
    return {
      inputFields: {},
      editRef: {},
      newInput: true,
      formShow: false,
      pagination: {
        rowsPerPage: 4
      },
      rowsPerPageItems: [4, 8, 12]
    }
  },
  methods: {
    cancelForm () {
      this.clearForm()
      this.formShow = false
    },
    clearForm () {
      for (var key in this.inputFields) {
        this.inputFields[key] = ''
      }
    },
    newEntry () {
      this.formShow = true
      this.newInput = true
    },
    editEntry (item) {
      for (var key in this.fields) {
        this.inputFields[key] = item[this.fields[key].name]
      }
      this.formShow = true
      this.newInput = false
      this.editRef = item
    },
    pushData () {
      if (this.newInput) {
        let newRecord = {}
        for (let fieldKey in this.inputFields) {
          newRecord[this.fields[fieldKey].name] = this.inputFields[fieldKey]
        }
        this.$firebaseRefs.channelValues.push(newRecord)
        this.clearForm()
        // this.$vuetify.goTo('Selector', '#dataAgg')
      } else {
        for (let fieldKey in this.inputFields) {
          this.$firebaseRefs.channelValues.child(this.editRef['.key']).child(this.fields[fieldKey].name).set(this.inputFields[fieldKey])
        }
        this.cancelForm()
      }
    }
  },
  computed: {
    projectid () {
      return this.$route.params.projectid
    },
    channelPath () {
      return this.$route.params.channelID
    },
    fields () {
      return this.$store.getters.selectedProjectData.dataFields[this.$route.params.channelID]
    },
    sortedFieldKeys () {
      // here we can sort field keys if ordering doesn't work on firebase return
      // for example we can iterated over sorted field keys like this
      // for ( skey in sortedFieldKeys) { this.fields[skey]}
      return null
    }
  },
  firebase: function () {
    return {
      channelValues: {
        source: db.ref('/projects/' + this.projectid + '/data/' + this.channelPath).limitToLast(4)
      }
    }
  },
  mounted () {
    for (var fieldKey in this.fields) {
      this.$set(this.inputFields, fieldKey, '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/TabularDataChannel.vue